// @see https://jsperf.com/object-values-vs-polyfill/2
// @see https://github.com/tc39/proposal-object-values-entries/blob/master/polyfill.js
// @see https://github.com/es-shims/Object.values/blob/master/implementation.js
if (!Object.values) {
  Object.values = function (obj) {
    'use strict'
    var result = []

    for (var k in obj) {
      if (
        typeof k === 'string' &&
        Object.prototype.propertyIsEnumerable.call(obj, k)
      )
        result.push(obj[k])
    }
    return result
  }
}
